/* import __COLOCATED_TEMPLATE__ from './edit-sh-payment-transaction-modal.hbs'; */
import { computed } from '@ember/object';
import { inject as service } from '@ember/service';
import LSGModalBase from "../lsg/lsg-modal-dialog-base";
import { SH_PAYMENT_TRANSACTION } from 'sh-www/models/sh-payment-transaction';
import { closeModal } from 'sh-www/utils/modal-controls';

export default LSGModalBase.extend({
  /**
   * Register services
   */
  store: service(),
  shPaymentTransactionCommandService: service('commands/sh-payment-transaction-commands'),

  /**
   * @inheritDoc
   */
  propertyDefaults: {
    /**
     * Pass in this as NULL will trigger the add experience.
     *
     * @param {ShPaymentTransaction}      Optional.
     */
    shPaymentTransaction: null,

    /**
     * @param {ShPayment}     Required
     */
    shPayment: null,

    /**
     * @param {Function}     Called after we have successfully edited a transaction
     */
    onTransactionEdited: (shPaymentTransaction) => {}
  },

  /**
   * @inheritDoc
   */
  stateDefaults: {
    /**
     * @type {String}
     */
    errorText: '',

    /**
     * @type {Boolean}      True when we are updating our state with db
     */
    isUpdating: false,

    /**
     * @type {Number}
     */
    updatedAmount: null,

    /**
     * @type {String}       of type SH_PAYMENT_TRANSACTION.PROCESSORS.*
     */
    updatedProcessorType: SH_PAYMENT_TRANSACTION.PROCESSORS.BANK,

    /**
     * @type {String}
     */
    updatedProcessorAccountId: '',

    /**
     * @type {String}
     */
    updatedProcessorTransactionId: ''
  },

  /**
   * @type {Boolean}      True if we are in the add mode vs edit
   */
  _isAddingNewTransaction: computed('model.shPaymentTransaction.id', function() {
    return !this.get('model.shPaymentTransaction.id');
  }),

  /**
   * @inheritDoc
   */
  _onInitializationComplete() {
    let shPaymentTransaction = this.get('model.shPaymentTransaction');

    if (shPaymentTransaction) {
      this.set('state.updatedAmount', shPaymentTransaction.get('amount'));
      this.set('state.updatedProcessorType', shPaymentTransaction.get('processor'));
      this.set('state.updatedProcessorAccountId', shPaymentTransaction.get('processorAccountId'));
      this.set('state.updatedProcessorTransactionId', shPaymentTransaction.get('processorTransactionId'));
    }
  },

  /**
   * options for the select for the processor type
   *
   * @type {Array<Object>}
   */
  _processorTypeSelectOptions: computed('state.updatedProcessorType', function() {
    return Object.values(SH_PAYMENT_TRANSACTION.MANUAL_PROCESSORS).reduce((accum, processorType) => {
      accum.push({
        key: processorType,
        value: processorType,
      });

      return accum;
    }, []);
  }),

  actions: {
    handleClose() {
      closeModal(this);
    },

    /**
     * @param {Object} option       from the select
     */
    onProcessorTypeSelected: function(option) {
      this.set('state.updatedProcessorType', option.value);
    },

    /**
     *
     */
    onUpdateLineItemClicked: function() {
      let amount = this.get('state.updatedAmount'),
        processorType = this.get('state.updatedProcessorType'),
        processorAccountId = this.get('state.updatedProcessorAccountId'),
        processorTransactionId = this.get('state.updatedProcessorTransactionId');

      if (!amount || !processorType || !processorAccountId || !processorTransactionId) {
        this.set('state.errorText', 'All must be filled in');
        return;
      }

      this.set('state.errorText', '');
      this.set('state.isUpdating', true);

      if (this.get('_isAddingNewTransaction')) {
        this.get('shPaymentTransactionCommandService').addTransaction(
          this.get('model.shPayment'),
          amount,
          processorType,
          processorAccountId,
          processorTransactionId
        ).then(shPaymentTransaction => {
          closeModal(this);
          this.get('model.onTransactionEdited')(shPaymentTransaction);
        }).catch(() => {
          // gobble gobble
        }).finally(() => this.set('state.isUpdating', false));
      } else {
        this.get('shPaymentTransactionCommandService').editTransaction(
          this.get('model.shPaymentTransaction'),
          amount,
          processorType,
          processorAccountId,
          processorTransactionId
        ).then(() => {
          let transaction = this.get('model.shPaymentTransaction');
          transaction.set('amount', amount);
          transaction.set('processor', processorType);
          transaction.set('processorAccountId', processorAccountId);
          transaction.set('processorTransactionId', processorTransactionId);

          closeModal(this);
          this.get('model.onTransactionEdited')(this.get('model.shPaymentTransaction'));
        }).catch(() => {
          // gobble gobble
        }).finally(() => this.set('state.isUpdating', false));
      }
    },

    onInputProcessorAccountId(accountId) {
      this.set('state.updatedProcessorAccountId', accountId);
    },

    onInputTransactionAmount(amount) {
      this.set('state.updatedAmount', amount);
    },

    onInputProcessorTransactionId(transactionId) {
      this.set('state.updatedProcessorTransactionId', transactionId);
    },

    closeModal() {
      closeModal(this);
    },
  }
});
